var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWatchWishListSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4,2C1.7939453,2,0,3.7939453,0,6s1.7939453,4,4,4s4-1.7939453,4-4S6.2060547,2,4,2z M4,8C2.8974609,8,2,7.1025391,2,6 s0.8974609-2,2-2s2,0.8974609,2,2S5.1025391,8,4,8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,12c-2.2060547,0-4,1.7939453-4,4s1.7939453,4,4,4s4-1.7939453,4-4S6.2060547,12,4,12z M4,18 c-1.1025391,0-2-0.8974609-2-2s0.8974609-2,2-2s2,0.8974609,2,2S5.1025391,18,4,18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,22c-2.2060547,0-4,1.7939453-4,4s1.7939453,4,4,4s4-1.7939453,4-4S6.2060547,22,4,22z M4,28 c-1.1025391,0-2-0.8974609-2-2s0.8974609-2,2-2s2,0.8974609,2,2S5.1025391,28,4,28z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 25,
    width: 22,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 15,
    width: 22,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 5,
    width: 22,
    height: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchWishListSmall);
export default __webpack_public_path__ + "static/media/watch-wish-list--small.ab092a923f0cb931ed96abb683b85e52.svg";
export { ForwardRef as ReactComponent };